module.exports = __webpack_public_path__ + "static/media/400041_02.c2183717.png";